
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Page from "@/src/components/Page";
import DocShell from "@/src/layouts/DocShell";
import DocNavItem from "@/src/components/docs/DocNavItem";
import H1 from "@/src/components/docs/H1";
import H2 from "@/src/components/docs/H2";
import CustomLink from "@/src/components/CustomLink";
import { IoRemoveOutline, IoEllipse } from "react-icons/io5";
import {
  Box,
  List,
  ListIcon,
  ListItem,
  Text,
  useColorMode,
} from "@chakra-ui/react";

const CookiePolicy = () => {
  const { t } = useTranslation("legal");
  const { colorMode } = useColorMode();
  const isLight = colorMode === "light";

  const bodyColor = isLight ? "inherit" : "white";
  const headingColor = isLight ? "inherit" : "brand.600";

  const list = (key) => t(key, null, { returnObjects: true }) || [];
  const sections = list("cookies.sections");

  // Paragraphe courant
  const P = ({ children, ...rest }) => (
    <Text
      as={"p"}
      color={bodyColor}
      py={2}
      lineHeight={"1.6"}
      textAlign={"justify"}
      {...rest}
    >
      {children}
    </Text>
  );

  // Liste à puces — « • » ou « – » selon la section, comme dans le document
  const Bullets = ({ items, dash }) => (
    <List spacing={3} mt={4} ml={{ base: 3, lg: 6 }}>
      {items.map((item, i) => (
        <ListItem key={i} color={bodyColor} lineHeight={"1.6"} textAlign={"justify"}>
          <ListIcon
            as={dash ? IoRemoveOutline : IoEllipse}
            color={"brand.500"}
            boxSize={dash ? 4 : 2}
          />
          {item}
        </ListItem>
      ))}
    </List>
  );

  const Site = ({ href, label }) => (
    <CustomLink to={href}>
      <Text as={"a"} color={"brand.500"}>
        {label}
      </Text>
    </CustomLink>
  );

  const Article = ({ children }) => (
    <Box as={"article"} py={4} px={{ base: 2, md: 8, xl: 12 }}>
      {children}
    </Box>
  );

  return (
    <DocShell
      aside={
        <>
          {sections.map((title, i) => (
            <DocNavItem key={i} icon={IoRemoveOutline} to={String(i + 1)}>
              {title}
            </DocNavItem>
          ))}
        </>
      }
    >
      <Article>
        <H1 color={headingColor}>{t("cookies.title")}</H1>

        <H2 color={bodyColor} py={2}>
          {t("cookies.subtitle")}
        </H2>

        <P>{t("cookies.intro1")}</P>
        <P>
          {t("cookies.intro2a")} <b>Watchman</b> {t("cookies.intro2b")}{" "}
          <Site href={"https://www.watchman.bj"} label={"www.watchman.bj"} />,{" "}
          {t("cookies.intro2c")}
        </P>
      </Article>

      {/* ── 1 ─────────────────────────────────────────────────────────────── */}
      <Article>
        <H1 color={headingColor} id={"1"} py={4}>
          1. {sections[0]}
        </H1>
        <Bullets
          dash
          items={[
            <React.Fragment key={"cookies-essentiels"}>
              <b>{t("cookies.s1.essentialLabel")}</b> :{" "}
              {t("cookies.s1.essential")}
            </React.Fragment>,
            <React.Fragment key={"cookies-analytiques"}>
              <b>{t("cookies.s1.analyticsLabel")}</b> :{" "}
              {t("cookies.s1.analytics")}
            </React.Fragment>,
          ]}
        />
        <P>{t("cookies.s1.footer")}</P>
      </Article>

      {/* ── 2 ─────────────────────────────────────────────────────────────── */}
      <Article>
        <H1 color={headingColor} id={"2"} py={8}>
          2. {sections[1]}
        </H1>
        <H2 color={bodyColor} py={2}>
          {t("cookies.s2.sub1")}
        </H2>
        <P>{t("cookies.s2.p1")}</P>
        <H2 color={bodyColor} pt={6} pb={2}>
          {t("cookies.s2.sub2")}
        </H2>
        <P>{t("cookies.s2.p2")}</P>
      </Article>

      {/* ── 3 ─────────────────────────────────────────────────────────────── */}
      <Article>
        <H1 color={headingColor} id={"3"} py={8}>
          3. {sections[2]}
        </H1>
        <P>{t("cookies.s3.p")}</P>
      </Article>

      {/* ── 4 ─────────────────────────────────────────────────────────────── */}
      <Article>
        <H1 color={headingColor} id={"4"} py={8}>
          4. {sections[3]}
        </H1>
        <P>{t("cookies.s4.p")}</P>
      </Article>
    </DocShell>
  );
};

const CookiePolicyPage = () => (
  <Page name="Cookie Policy" path="/docs/cookie-policy">
    <CookiePolicy />
  </Page>
);

export default CookiePolicyPage;


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/docs/cookie-policy',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  